
import { Service } from "@/types/marketplace";
import { ServiceCard } from "@/components/marketplace/ServiceCard";
import { TooltipProvider } from "@/components/ui/tooltip";

interface MarketplaceGridProps {
  services: Service[];
  onHire: (id: number) => void;
  onContact: (id: number) => void;
}

export const MarketplaceGrid = ({ services, onHire, onContact }: MarketplaceGridProps) => {
  if (services.length === 0) {
    return (
      <div className="text-center py-12">
        <h3 className="text-lg font-medium text-gray-900 mb-2">No services found</h3>
        <p className="text-gray-600">Try adjusting your search criteria</p>
      </div>
    );
  }

  return (
    <TooltipProvider>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {services.map((service) => (
          <ServiceCard
            key={service.id}
            service={service}
            onHire={onHire}
            onContact={onContact}
          />
        ))}
      </div>
    </TooltipProvider>
  );
};
